import angular from 'angular';
import scenes from './scenes';
import tabContent from './tabContent';
import './style.scss';

export default angular
  .module('scenes.tabContent', [scenes])
  .component('tabContent', tabContent).name;
